import { type FC, type PropsWithChildren, useMemo, useState } from 'react';

import { type IOfferForDesktopEnrichedV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopEnrichedV3Schema';

import { HoveredOfferActionsContextProvider, HoveredOfferContextProvider } from '../../context/HoveredOfferContext';

export const HoveredOfferProvider: FC<PropsWithChildren> = ({ children }) => {
  const [hoveredOffer, setHoveredOffer] = useState<IOfferForDesktopEnrichedV3Schema>();

  const hoveredOfferActionsContext = useMemo(
    () => ({
      onOfferHover: setHoveredOffer,
      onOfferBlur: (): void => setHoveredOffer(undefined),
    }),
    [],
  );

  const hoveredOfferContext = useMemo(() => ({ hoveredOffer }), [hoveredOffer]);

  return (
    <HoveredOfferContextProvider value={hoveredOfferContext}>
      <HoveredOfferActionsContextProvider value={hoveredOfferActionsContext}>
        {children}
      </HoveredOfferActionsContextProvider>
    </HoveredOfferContextProvider>
  );
};
